module.exports = __WEBPACK_EXTERNAL_MODULE_78__;


//////////////////
// WEBPACK FOOTER
// external {"root":"ReactDOM","commonjs2":"react-dom","commonjs":"react-dom","amd":"react-dom"}
// module id = 78
// module chunks = 0